//NG+
import { AppSettings } from "../app-settings";
import { UserSettingsService } from "./user-settings-service";

import { NGXLogger } from "ngx-logger";
import { HttpClient, HttpParams, HttpResponse } from "@angular/common/http";
import {  logUserGIS, } from "../roles/settings-components/settings-definitions";
import { getExMessage, isArray, isObject } from "../map/map-utils";
import moment from 'moment';


export interface IDbStoreUserLogs {
    getIstoricUserLogs(pagina: number, idUser:number, tipLog: string): Promise<{ maxPages: number, tasks: Array<logUserGIS> }>;
   
}

export class DbStoreUserLogs implements IDbStoreUserLogs {

    constructor(
        private $http: HttpClient,
        private $log: NGXLogger,
        private settingsService: UserSettingsService) { }

   
    //
    public getIstoricUserLogs(pagina: number,idUser:number, tipLog: string): Promise<{ maxPages: number, tasks: Array<logUserGIS> }> {
        return this.$http.get(
            AppSettings.serverPath + '/userLogs/history/' + pagina,
            {
                params: { "tipLog": tipLog || "", "idUser": idUser || ""},
                observe: "response"
            })
            .toPromise()
            .then((response) => {
                let result: { maxPages: number, tasks: Array<logUserGIS> } = { maxPages: 0, tasks: [] };
                if (response.body && isObject(response.body)
                    && response.body.hasOwnProperty('nrMaxPagini')
                    && response.body.hasOwnProperty('date')
                    && isArray(response.body['date'])) {
                    result.maxPages = response.body['nrMaxPagini'] || 0;
                    let resArray = response.body['date'] as Array<any>;
                    for (let index = 0; index < resArray.length; index++) {
                        let resItem: logUserGIS =
                        {
                            id: -1, time: '', idUser: -1, username: '', idClient: -1, type: '',
                            action: '', info: '', status: ''}
                            
                        try {
                            const restsk = resArray[index];
                            //
                            resItem.id = restsk.id;
                            // Convert UTC timestamp to local time using moment
                            resItem.time = moment.utc(restsk.timestamp).local().format('DD.MM.YYYY HH:mm:ss');
                            resItem.idUser = restsk.idUser;
                            resItem.username = restsk.username;
                            resItem.idClient = restsk.idClient;
                            resItem.info = restsk.info;
                            resItem.status = restsk.status;
                            resItem.type = restsk.type;
                            resItem.action = restsk.action;
                        } catch (error) {
                            resItem.status = 'eroare';
                            resItem.info = 'eroare extragere date log utilizator';
                            this.$log.error("eroare extragere date log utilizator");
                        }
                        result.tasks.push(resItem);
                    }
                }
                return result;
            });
    }

  

    
}
